<template>
  <div
    style="
      position: absolute;
      height: calc(100vh + 64px);

      bottom: 0;
      width: 100%;
      z-index: 1;
      overflow-y: auto;
    "
    class="background"
  >
    <div
      class="px-6 pb-6 d-flex flex-column white--text"
      style="
        height: 80vh;
        overflow-y: scroll;
        position: fixed;
        width: 100%;
        margin-top: 12vh;
      "
    >
      {{ $t("info.description") }}
      <br />
      <br />
      <div class="mt-8" v-html="$t('info.credits')"></div>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  mounted() {
    this.setMenuIconColor("white");
  },

  onUnmounted() {
    this.setMenuIconColor("blue");
  },

  methods: {
    ...mapMutations(["setMenuIconColor"]),
  },
};
</script>

<style scoped lang="scss"></style>
